import { render, staticRenderFns } from "./BecomePro.vue?vue&type=template&id=ea052f0c&scoped=true&"
import script from "./BecomePro.vue?vue&type=script&lang=js&"
export * from "./BecomePro.vue?vue&type=script&lang=js&"
import style0 from "./BecomePro.vue?vue&type=style&index=0&id=ea052f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea052f0c",
  null
  
)

export default component.exports